import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { useFcm } from '@/hooks/useFcm';

export default function RootLayout() {
  const { pathname } = useLocation();
  // Messaging owns its own full-height layout; skip the footer there.
  const isChat = pathname.startsWith('/mesajlar');

  useFcm();

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1" id="main-content">
        <Outlet />
      </main>
      {!isChat && <Footer />}
    </div>
  );
}
